(function($) {

  function bindSearchFormEvents(context) {

    context = context || document;

    if ($('.js-days-select', context).length > 0) {
      $('.js-days-select', context).change(function() {
        var id = $(this).val();
        $('.js-dates-select', context).removeClass('active').attr('disabled','disabled');
        $('#dates-select-' + id, context).removeAttr('disabled').addClass('active');

        SearchService.search();

      })
    }

    $('.js-dates-select', context).change(function() {
      SearchService.search();
    });

    $('#search-sorting a.js-sort', context).click(function() {
      var $this = $(this),
          type = $this.data('sort-type'),
          order = $this.data('sort-order');

      //Remove other displaying sorts
      $this.closest('.js-search-sorting').
      find('.js-sort-label').
      each(function() {
        var $label = $(this);
        if($label.data("original-label")) {
          $label.text($label.data("original-label"));
        }
      });

      //Display the current sort
      $label = $this.closest('.js-sort-menu').find('.js-sort-label');
      $label.data('original-label', $label.text());
      $label.text($this.text());

      SearchService.sort(type, order);
    });

    $('#search-filters .js-filter', context).change(function() {
      SearchService.search();
    });


    $('.js-show-search-form', context).click(function(e) {

      var html = '<div id="modal-search-form" class="reveal-modal tiny" data-reveal aria-labelledby="modalTitle" aria-hidden="true" role="dialog">' +
                 '<h2  id="modalTitle">Selecciona otra fecha</h2>' +
                 '<div class="js-modal-content"></div>' +
                 '<a class="close-reveal-modal" aria-label="Close">&#215;</a></div>'; 

      
      e.preventDefault();
      
      if ($('#modal-search-form').length == 0) {

        $('body').append(html);

        $(document).on('close.fndtn.reveal', '[data-reveal]', function () {
          if ($(this).attr('id') == 'modal-search-form') {
            $('#modal-search-form #search-form').prependTo('.fixed-box');
            $('[name=destination]', '#search-form').searchAutocomplete('enable');
            $('[name=destination]', '#search-form').off('keydown');
          }
        });
        
      }
      
      $('#search-form').appendTo($('.js-modal-content', '#modal-search-form'));
      $('#modal-search-form').foundation('reveal','open');

      $('[name=destination]', '#modal-search-form').searchAutocomplete('disable');
      $('[name=destination]', '#modal-search-form').on('keydown', function(e) { e.preventDefault(); } );


    });

  }

  //Serch service autocomplete
  var SearchService = {
    cache: [],
    lastItem: null,
    container: null,
    forceClickSearchButton: false,

    setContainer: function(container) {
      this.container = container;
    },

    initAutocomple: function() {
      var self = this;

      $.get(UNISKI_SETTINGS.baseURL + 'search/autocomplete', {term: '#all#'})
      .then(function(res) {
        self.cache = res;
      });

    },

    autocomplete : function(term, response) {
      var data = [];
      if (this.cache.length > 0) {
        for (var i = 0; i < this.cache.length; i++) {
          var item = this.cache[i].label.toLowerCase().split(',')[0];
          if (item.indexOf(term.toLowerCase()) >= 0) {
            data.push(this.cache[i]);
          }
        }
      }

      this.lastItem = data[0];

      if (data.length > 0) return response(data);

      $.get(UNISKI_SETTINGS.baseURL + 'search/autocomplete', {term: term})
      .then(function(res) {
        this.lastItem = res[0];
        response(res);
      });
    },

    getLastItem: function() {
      return this.lastItem;
    },

    setData: function(container, item) {
      $('[name="entity[type]"]', this.container).val(item.entity.type);
      $('[name="entity[value]"]', this.container).val(item.entity.id);
      this.forceClickSearchButton = true;
    },

    getData: function(container) {
      return item = {
        type: $('[name="entity[type]"]', this.container).val(),
        value: $('[name="entity[value]"]', this.container).val()
      };
    },

    //
    //
    //  Filters of the search form
    //
    //
    _sort : {},

    //returns a promise
    serialize: function(obj, param) {
      q = [];
      for(prop in obj) {
        q.push(param+"["+prop+"]="+obj[prop])
      }
      return encodeURI(q.join('&'));
    },

    getSerializedData: function() {
      data = $(this.container).serialize();

      //Search filters are outside of container
      data += "&" + $('#search-filters').serialize();

      data += "&" + this.serialize(this._sort, 'sort');

      return data;
    },

    search: function(updateDestinationOptions) {
      var dateIn, dateOut;

      if (this.forceClickSearchButton === true) return false;

      updateDestinationOptions = updateDestinationOptions  === undefined ? false: true;
       
      $('.js-search-results').addClass('js-searching');
      $.get(UNISKI_SETTINGS.baseURL + 'search?' + this.getSerializedData())
      .then(function(res, textStatus, jqXHR) {

        //TODO: if redirect (302, etc) change navigator URL eventhough it means hit the same URL twice.
        //jqXHR.getResponseHeader
        console.log(jqXHR.status); 

        var $res = $($.parseHTML(res));

        var list            = $res.find('.js-search-results').html();
        var message         = $res.filter('.js-message-container').html();
        var productOptions  = $res.filter('.js-product-options').html();

        var newDatesDiv     = $res.find('.js-new-dates');

        if (newDatesDiv.length == 1) {
          dateIn = new Date(newDatesDiv.data('new-date-in'));
          dateOut = new Date(newDatesDiv.data('new-date-out'));
          updateDates(dateIn, dateOut);
        }
        
        $('.js-search-results')
        .html(list)
        .removeClass('js-searching');

        $('.js-message-container').html(message)

        bindSearchFormEvents('.js-search-results');

        if (updateDestinationOptions) {
          $('.js-product-options')
          .html(productOptions);
          bindSearchFormEvents('.js-product-options');
        }

        $(document).foundation();
        UNISKI_SETTINGS.bindEvents('.js-search-results');
        UNISKI_SETTINGS.bindEvents('.js-message-container');

      });
    },

    sort : function(type, order) {
      //remove other sorts, allow only one sort at time
      this._sort = {};
      this._sort[type] =order
      return this.search();
    },

  };

  //Extend autocomplete widget
  $.widget('custom.searchAutocomplete', $.ui.autocomplete,{
    _renderItem: function( ul, item ) {
      return $( "<li>" )
        .append( $( '<div class="'+item.entity.type+'">' ).text( item.label ) )
        .appendTo( ul );
    },
  });


  function updateDates(dateIn, dateOut) {

    var $dateIn = $('[name=dateIn]');
    var $dateOut = $('[name=dateOut]'); 

    updateDateDisplay($('.js-date-in-label'), dateIn);
    $dateIn.datepicker('setDate', dateIn);

    updateDateDisplay($('.js-date-out-label'), dateOut);
    $dateOut.datepicker('setDate', dateOut);

  }




  function updateDateDisplay($display, date) {
    var text = $.datepicker.formatDate("DD d, MM, yy", date);
    if ($display.width() < 170) text = text.substr(0,20) + '...';
    $display.text(text);
  }

  function initDatePickers(container) {

    var $dateIn = $('[name=dateIn]', container);
    var $dateOut = $('[name=dateOut]', container);

    $dateIn.datepicker({
      numberOfMonths: 2,
      firstDay: 1,
      minDate: 0,
      dateFormat: 'yy-mm-dd',
      onSelect: function() {
        var day = $(this).datepicker('getDate'),
            next = Utils.getNextDay(day);
        updateDateDisplay($('.js-date-in-label', container), day);
        updateDateDisplay($('.js-date-out-label', container), next);
        $dateOut.datepicker('setDate', next);

        $dateOut.data('dateHasChanged', true);

        setTimeout(function(){
          $dateOut.datepicker('show');
        },200);

      }
    });

    $dateOut.datepicker({
      numberOfMonths: 2,
      firstDay: 1,
      minDate: 0,
      dateFormat: 'yy-mm-dd',
      onSelect: function() {
        var day = $(this).datepicker('getDate');
        $(this).data('dateHasChanged', true);
        //SearchService.search();
        updateDateDisplay($('.js-date-out-label', container), day);
      },

      onClose: function() {
        if ($(this).data('dateHasChanged') &&
            !UNISKI_SETTINGS.isFrontPage) {

          $('.js-product-options').html('');
          $(this).data('dateHasChanged',false);

          SearchService.search(true);

        }
      }
    });

    var now = $dateIn.val() ? new Date($dateIn.val()) : Utils.getFirstDay();
    updateDateDisplay($('.js-date-in-label', container), now);
    $dateIn.datepicker('setDate', now);

    var next = $dateOut.val() ? new Date($dateOut.val()) : Utils.getNextDay(now);
    updateDateDisplay($('.js-date-out-label', container), next);
    $dateOut.datepicker('setDate', next);

    //Bind events
    $('.js-date-in-box', container).click(function(){ $dateIn.datepicker('show') });
    $('.js-date-out-box', container).click(function(){ $dateOut.datepicker('show') });

    $(window).resize(function() {
      updateDateDisplay($('.js-date-in-label', container), $dateIn.datepicker('getDate'));
      updateDateDisplay($('.js-date-out-label', container), $dateOut.datepicker('getDate'));
    });

  }

  function initSearchForm(context, container) {

    var context = context || document;
    var container = container || $('#search-form', context);

    SearchService.setContainer(container);
    
    $(container)[0].reset();

    //Init dates
    initDatePickers(container);

    container.on('submit', function() {

      if ($('input[name=dateIn]').val() != '' &&
          $('input[name=dateOut]').val() != '' &&
          $('input[name=rooms]').val() != '' &&
          $('input[name="entity[value]"]').val() != '' &&
          $('input[name="entity[type]"]').val() != 'target')
      {
        //TODO: use context in order to submit form or
        //send ajax request
        return true;
      }
      return false;
    });

    //Initalize rooms Form
    roomsForm.init({
      context: $('#room-picker-modal'),
      onCloseForm: function(description, firstTime) {
        $('#search-form #display').text(description);

        if (!firstTime && !UNISKI_SETTINGS.isFrontPage)  {
          //Weird behavior. As room info is in a foundation modal dialog
          //the DOM is not really updating until it really closes down
          //so we wait a bit
          setTimeout(SearchService.search.bind(SearchService), 500);

        }
      }
    });

    //Intialize search autocomplete
    $('[name=destination]', container).searchAutocomplete({
      create: function() {
        SearchService.initAutocomple();
      },
      source: function(request, response) {
        SearchService.autocomplete(request.term, response);
      },
      select: function(event, ui) {
        SearchService.setData(container, ui.item);
      },
      change: function(event, ui) {
        if (ui.item === undefined || ui.item === null) {
          ui.item = SearchService.getLastItem();
          if (ui.item === undefined) return false;
          $(this).data('custom-searchAutocomplete')._trigger('select','autocompleteselect', ui);
          $(this).val(ui.item.label);
        }
      },
      minLength: 2
    })
    .keyup(function(e) {

      if ($(e.target).searchAutocomplete('option', 'disabled') === true) return false;

      if (e.which != 13) {
        SearchService.setData(container, {entity: {type: '', value: ''}});
      } else if(SearchService.getData().value == '') {
        //Force update autocomplete if we hit enter when typing product
        $(this).data('custom-searchAutocomplete')._trigger('change',{});
      }
    });

    bindSearchFormEvents(context);

  }

  window.initSearchForm = initSearchForm;

})(jQuery);
